import { FILTER_TYPES } from 'components/FilterPod';
import { STATUS_CODE_OPTIONS } from '../../constants/Options';

const filters = (currencyText) => [
  {
    title: 'شناسه کاربر',
    label: 'شناسه کاربر',
    keyName: 'userId',
    query: 'userId',
    id: 3335,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },

  {
    title: 'محدوده‌ مبلغ مورد نظر',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    unit: currencyText,
    keyName: 'amountRange',
    id: {
      start: 3338,
      end: 3339,
    },
    value: {
      start: null,
      end: null,
    },
    query: {
      start: 'fromAmount',
      end: 'toAmount',
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },
  {
    title: 'شناسه تسهیلات',
    label: 'شناسه تسهیلات',
    keyName: 'id',
    query: 'id',
    id: 3334,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },

  {
    title: 'وضعیت تسهیلات',
    label: 'وضعیت تسهیلات',
    keyName: 'statusCode',
    query: 'statusCode',
    id: 3345,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: STATUS_CODE_OPTIONS,
    },
  },
];

export default filters;
